var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full h-full flex flex-col items-center justify-center gap-[8px]"},[_c('spinner'),_c('span',{staticClass:"text-[#3C444B] text-[24px] font-[600] mt-[14px]"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"text-[#747B83] text-[20px] font-[400]"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }